import { inject } from "@angular/core";
import { Store } from "@ngrx/store";
import { Location } from "@angular/common";
import { Observable } from "rxjs";
import { initAdminAuth } from "../../../core/auth/store/auth.actions";

export const initializeApplication = () => {
  const store = inject(Store);
  const location = inject(Location);

  return new Observable<void>((subscriber) => {
    const exemptedPaths = [
      '/auth/callback',
      '/invited-user',
      '/registration',
      '/otp/changepassword',
      '/change-password',
    ];

    const currentPath = location.path();
    const isPathExempted = exemptedPaths.some((path) => currentPath.startsWith(path));

    if (isPathExempted) {
      subscriber.complete();
      return;
    }

    store.dispatch(initAdminAuth());

    subscriber.next();
    subscriber.complete();
  });
};
